import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { useRadioCard } from './hook';
const Radio = styled.input `
  opacity: 0;
  width: 0;
  position: fixed;
`;
const Label = styled.label(({ theme, variant, px, py, fullWidth }) => `
  flex: ${fullWidth ? '1' : '0'};
  font-size: ${theme.fontSizes.x1};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.success};
  min-width: max-content;
  text-align: center;
  text-transform: uppercase;
  display: inline-block;
  cursor: pointer;
  padding: ${py ? theme.space[py] : theme.space.x8} ${px ? theme.space[px] : theme.space.x16};
  border: ${variant === 'emphasized' ? '2px solid' : '1px solid'};
  border-color: ${variant === 'emphasized' ? theme.colors.success : theme.colors.gray200};
  border-radius: ${theme.space.x8};
  ${theme.media.above('sm')} {
    padding: ${py ? theme.space[py] : theme.space.x8} ${px ? theme.space[px] : theme.space.x24};
  }

  :focus:not(:focus-visible) {
    outline: none;
  }

  :focus-visible {
    outline: 2px solid ${theme.colors.kiwiLight};
  }
  &:hover {
    border-color: ${variant === 'emphasized' ? theme.colors.success : theme.shadows.gray32};
    box-shadow: ${theme.shadows.gray32};
  }
  `);
export const RadioCardItem = forwardRef(({ value, label, id, disabled }, ref) => {
    const { name, onChange, value: controlledValue, variant, px, py, fullWidth, } = useRadioCard();
    const isSelected = controlledValue === value;
    return (React.createElement(React.Fragment, null,
        React.createElement(Radio, { type: "radio", name: name, ref: ref, id: id, checked: isSelected, value: value, onChange: e => {
                onChange(e.target.value);
            }, disabled: disabled, tabIndex: -1, "aria-hidden": true }),
        React.createElement(Label, { htmlFor: id, variant: variant, tabIndex: disabled ? -1 : 0, onKeyPress: (e) => {
                if (e.key === 'Enter') {
                    e.target.previousSibling.click();
                }
            }, px: px, py: py, fullWidth: fullWidth }, label)));
});
RadioCardItem.displayName = 'RadioCardItem';
//# sourceMappingURL=RadioCardItem.js.map